import { toPascalCase, toCamelCase, capitalize, getId } from './util';
import { jobsByRole } from "./jobs";

const checklist = (role) => ({
  role: role,
  items: jobsByRole(role),
  selected: [],

  init() {
    this.$watch('selected', () => {
      const head = getId(this.checklistHeadId());
      head.indeterminate = (this.selected.length > 0 && this.selected.length < this.items.length);
    });
  },

  checklistId() {
    return 'settingsJob' + capitalize(this.role);
  },

  checklistHeadId() {
    return 'jobHead' + capitalize(this.role);
  },

  checklistHeadText() {
    const translationKey = 'jobs.' + this.role;
    return this.$t(translationKey);
  },

  checklistHeadState() {
    return (this.selected.length == this.items.length);
  },

  checklistHeadIndeterminateState() {
    return this.selected.length > 0 && this.selected.length < this.items.length;
  },

  checklistItemId(item) {
    return 'jobItem' + capitalize(this.role) + toPascalCase(item.jobName);
  },

  checklistItemText(item) {
    const translationKey = 'jobs.' + toCamelCase(item.jobName);
    return this.$t(translationKey);
  },

  toggleItem: {
    ['@change'](e) {
      const job = e.target.id;
      this.$nextTick(() => {
        this.$data.toggleDisplay(job);
      });
    }
  },

  toggleAll: {
    ['@change'](e) {
      this.$nextTick(() => {
        const ids = this.items.map(i => this.checklistItemId(i));
        if (this.selected.length === this.items.length) {
          this.$data.setDisplay(ids, []);
        } else if (this.selected.length === 0) {
          this.$data.setDisplay([], ids);
        } else {
          const absent = this.items.filter(x => !this.selected.includes(x));
          this.$data.setDisplay(selected, absent)
        }
      });
    },

    ['@click']() {
      const id = toCamelCase(`job item ${this.role}`);
      const children = document.querySelectorAll(`[id^=${id}]`);

      if (this.selected.length === this.items.length) {
        this.selected = [];
      } else {
        this.selected = [...this.items].map((item) => (this.checklistItemId(item)));
      }
    }
  },
});

export default checklist;
